import type { Guideline as GuidelineType } from "@/lib/stores/canvas-store/canvas-snapping";
import type { Resolution } from "./canvas-geometry";

type Props = {
  guideline: GuidelineType;
  resolution: Resolution;
};

export default function Guideline({ guideline, resolution }: Props) {
  const { orientation, position, from, to } = guideline;
  const style =
    orientation === "vertical"
      ? {
          left: `${(position / resolution.width) * 100}%`,
          top: `${(from / resolution.height) * 100}%`,
          height: `${((to - from) / resolution.height) * 100}%`,
        }
      : {
          top: `${(position / resolution.height) * 100}%`,
          left: `${(from / resolution.width) * 100}%`,
          width: `${((to - from) / resolution.width) * 100}%`,
        };

  return (
    <div
      className={
        orientation === "vertical"
          ? "pointer-events-none absolute w-px bg-red-500"
          : "pointer-events-none absolute h-px bg-red-500"
      }
      style={style}
    />
  );
}
